<template>
  <div class="container-fluid dmbs-top-menu pb-0">
    <template>
      
      <v-toolbar
        color="tranparent"
        flat
        class="hidden-md-and-up menu"
      >
        <v-toolbar-title>
          <router-link
            class="navbar-brand"
            :to="`/${$i18n.locale}/`"
          >
            <img
              alt="Kutxabank"
              src="../../assets/cropped-K_entradas_hor_cas.jpg"
              style="height: 50px;"
              class="hidden-lg hidden-md hidden-sm visible-xs"
            >
          </router-link>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        
        <v-toolbar-side-icon @click="menuMovil = !menuMovil" ></v-toolbar-side-icon>

      </v-toolbar>
    </template>
    <template>
      <v-toolbar
        height="50px"
        flat
        color="tranparent"
        class="cabecera mb-4 hidden-sm-and-down"
      >
        <v-toolbar-items>
          <div class="text-xs-center">
            <v-btn
              class="text-capitalize desplegable"
              flat
              :to="`/${$i18n.locale}/`"
            >
              {{$t('Inicio')}}
            </v-btn>
            <v-menu offset-y>
              <v-btn
                slot="activator"
                class="text-capitalize"
                flat
              >
                {{$t('Categorías')}}<span class="caret"></span>
              </v-btn>

              <v-list>
                <v-list-tile
                  v-for="(item, index) in categorias"
                  :key="index"
                  :to="`/${$i18n.locale}/cat/${item.id}`"
                >
                  <v-list-tile-title>{{ $t(item.nombre) }}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
            <v-menu offset-y>
              <v-btn
                slot="activator"
                class="text-capitalize"
                flat
              >
                {{$t('Consultas de Entradas')}}<span class="caret"></span>
              </v-btn>
                
              <v-list>
                <v-list-tile :to="`/${$i18n.locale}/mis-operaciones`">
                  <v-list-tile-title>{{$t(consultasEntradas[0].nombre)}}</v-list-tile-title>
                </v-list-tile>
                <v-list-tile :href="entradasUrl" target="_blank">
                  <v-list-tile-title>{{$t(consultasEntradas[1].nombre)}}</v-list-tile-title>
                </v-list-tile>
                <v-list-tile :to="`/${$i18n.locale}/como-comprar`" > 
                  <v-list-tile-title>{{$t(consultasEntradas[2].nombre)}}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
            <v-menu offset-y>
              <v-btn
                slot="activator"
                class="text-capitalize"
                flat
              >
                {{$t('Eventos')}}<span class="caret"></span>
              </v-btn>

              <v-list>
                <v-list-tile
                  v-for="(item, index) in provincias"
                  :key="index"
                  :to="`/${$i18n.locale}/loc/${item.id}`"
                >
                  <v-list-tile-title>{{ $t(item.nombre) }}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
            <v-menu offset-y>
              <v-btn
                slot="activator"
                class="text-capitalize"
                flat
              >
                {{$t('Recintos')}}<span class="caret"></span>
              </v-btn>

              <v-list>
                <v-list-tile
                  v-for="(item, index) in recintos"
                  :key="index"
                  :to="`/${$i18n.locale}/recintos/${item.id}`"
                >
                  <v-list-tile-title>{{ $t(item.nombre) }}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </div>
        </v-toolbar-items>
      </v-toolbar>
    </template>
  </div>
</template>
<style>
.navbar-default .navbar-nav > .active > a,
.navbar-default .navbar-nav > .active > a:focus {
  color: #000;
}

li.active:first-child > a {
  background: white !important;
  color: black;
}

.active a {
  color: black;
}

li.active.router-link-exact-active:first-child > a {
  color: #555 !important;
  background: #e7e7e7 !important;
}

.v-toolbar__content {
  background: white;
}

button.text-capitalize.v-btn.v-btn--flat.theme--light {
  border-left: 1px solid #f2f2f2;
}

nav.v-toolbar.elevation-0.theme--light.tranparent {
  border: 1px solid #e7e7e7;
  border-radius: 10px;
}
.cabecera button.text-capitalize.v-btn.v-btn--flat.theme--light {
  height: 50px;
}
.cabecera .v-btn__content {
  height: 50px;
}
.desplegable .v-list__tile.v-list__tile--link.theme--light {
    height: 35px;
}
</style>

<script>
import { globales } from "../../components/comunes";

export default {
  mixins: [globales],
  computed: {
    entradasUrl(){
      const lang = this.$i18n.locale
      const Url = `https://portal.kutxabank.es/cs/Satellite?pagename=PortalKutxabank/Page/PK_BuscadorRecogidaEntradas&hizkuntza=${lang}&kutxabank=si`
      return Url
    }
  },
  data() {
    return {
      menu: [
        { texto: "Inicio", to: "/", tipo: "pagina" },
        { texto: "Eventos", to: "/eventos", tipo: "pagina" },
        { texto: "Musicales", to: "/musicales", tipo: "pagina" }
      ]
    };
  }
};
</script>
